
export const reducerTextValues = {
    somethingWentWrong: 'Something went wrong.',
};
